<template>
    <div class="avarage">
        <div class="min avarage-count">
            <span class="avarage-count-top"> {{min | moneyFormat}} TL</span>
            <span class="avarage-count-center"><em class="bar"></em></span>
            <span class="avarage-count-bottom is-uppercase"> en düşük </span>
        </div>
        <div class="center avarage-count">
            <span class="avarage-count-top"> {{center | moneyFormat}} TL</span>
            <span class="avarage-count-center"><em class="bar"></em></span>
            <span class="avarage-count-bottom is-uppercase"> ortalama </span>
        </div>
        <div class="max avarage-count">
            <span class="avarage-count-top"> {{max | moneyFormat}} TL</span>
            <span class="avarage-count-center"><em class="bar"></em></span>
            <span class="avarage-count-bottom is-uppercase"> en yüksek </span>
        </div>
    </div>
</template>
<script>
    export default{
        name: 'Avarage',
        props:['min','center','max'],
        filters:{
            moneyFormat : (value)=>{
                return new Intl.NumberFormat('tr-TR').format(value)
            }
        }
    }
</script>